export default __webpack_public_path__ + "static/media/sharePrivate.a32f1509.svg";